import React from "react";
import { Modal } from "react-bootstrap";
import "./PromoCodeComponent.css";
import { IoMdClose } from "react-icons/io";

const PromoCodeEditGroupModal = ({
  showEditGroupModal,
  handleCloseEditGroupModal,
  allUsers,
  setSelectedEmail,
  groupEmailData,
  setGroupEmailData,
  handleSavePromoGroup
}) => {
  
  return (
    <div>
      <Modal
        show={showEditGroupModal}
        onHide={handleCloseEditGroupModal}
        backdrop="static"
        className="edit-group-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Group Users</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-lg-2 col-sm-12">
            <div className="form-group">
              <label for="userList">Add More Users</label>
              <select
                name=""
                id=""
                className="form-control"
                onChange={(e) => {
                  const selectedValue = e?.target?.value;
                  const selectedItem = allUsers?.find(
                    (item) => item?.Id === selectedValue
                  );
                  setSelectedEmail(selectedItem);
                  const checkEmail = groupEmailData?.find(
                    (i) => i.trim() === selectedItem?.Email.trim()
                  );
                  if (!checkEmail) {
                    const filter = [...groupEmailData, selectedItem?.Email];
                    setGroupEmailData(filter);
                  }

                  e.target.value = "";
                }}
              >
                <option value="">Select Email</option>
                {allUsers?.map((item) => {
                  return (
                    <option value={item?.Id}>
                      {item?.Email ? item?.Email : null}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="pro_selected_user">
              <div className="form-group">
                <label>Selected Users</label>
                <div className="row">
                  {groupEmailData?.map((item) => {
                    return (
                      <div className="col-lg-3 col-md-4 col-sm-6 mb-2">
                        <div className="selected-user d-flex align-items-center">
                          <input
                            type="text"
                            className="form-control me-2"
                            readonly=""
                            value={item}
                          />
                          <IoMdClose
                            className="cross_butt_email"
                            onClick={() => {
                              const filter = groupEmailData?.filter(
                                (i) => i !== item
                              );
                              setGroupEmailData(filter);
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-2 col-sm-6 col-12" >
            <button
              type="button"
              className="btn btn-primary common_btn_pd"
              onClick={handleSavePromoGroup}
            >
              Update
            </button>
          </div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </div>
  );
};

export default PromoCodeEditGroupModal;
